// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__VSRtD","active":"styles_active__kRoOU"};